// extracted by mini-css-extract-plugin
export default {"bannerImageToggle":"P4edx___BrandedAssets-module__bannerImageToggle"};